// 诉讼管理
var AssistCase = function () { return import('~/pages/assist-manage/assist-case.vue'); };
var AssistVisitStay = function () { return import('~/pages/assist-manage/assist-visit-stay.vue'); };
export default [
    {
        path: '/assist-stay/assist-visit-stay',
        name: 'assist-visit-stay',
        component: AssistVisitStay // 待分配案件池
    },
    {
        path: '/assist-stay/assist-case',
        name: 'assist-case',
        component: AssistCase // 诉讼案件
    }
];
